<template>
  <div class="register-page">
    <div class="row align-items-center header">
      <div class="page-title col-xs-12 col-sm-6 pt-2">
        Registrar / usuários ({{ list.length }})
      </div>
      <toolbar
        class="col-xs-12 col-sm-6"
        type="users"
        :is-mobile="mobile"
        :is-searching="isSearching"
        @search="searchBy"
        @clear-search="clearSearch"
        @edit="edit"
        @remove="remove()"
        @add="add"
        ref="INP"
        :is-admin="isAdmin"
        :active-user-id="activeUser.ID"
        :selected="selected"
        :number-of-elements="list.length"
        :type-filtering="''"
        :is-show="loading"
        :not-exists="showErrorNotFound"
        :not-search="showErrorNotSearch"
      />
    </div>
    <div class="container-dropdown">
      <div class="row around-xs">
        <div class="col-xs-6 pt-1">
          <b-button
            block
            size="sm"
            to="/registers/user"
            :variant="!isGroup ? '3v3' : 'outline-3v3'"
            >USUÁRIOS</b-button
          >
        </div>
        <div class="col-xs-6 pt-1">
          <b-button
            block
            size="sm"
            to="/registers/user/groups"
            :variant="isGroup ? '3v3' : 'outline-3v3'"
            >GRUPOS</b-button
          >
        </div>
      </div>
    </div>

    <div class="register-main">
      <div class="list-items row">
        <div v-if="loading" class="col-xs-12 center-xs">
          <spinner /> Aguarde...
        </div>

        <div
          v-if="showErrorNotFound"
          class="EmptyRequest w-100 h-100 p-0 row center-xs center-md center-sm center-xs mt-3"
        >
          <img :src="emptyIcon" class="empty" />
          <span>Não há usuários para exibir.</span>
        </div>

        <div
          v-if="showErrorNotSearch && !showErrorNotFound"
          class="EmptyRequest row center-xs mx-2 md-12 w-100 p-0 mt-3"
          style="text-align: left"
        >
          <img :src="searchIcon" class="empty" />
          <span>
            Nenhum resultado encontrado. Para voltar a exibir todos os usuários
            <b-link
              @click="
                (evt) => {
                  resetDropdown();
                }
              "
            >
              clique aqui </b-link
            >.</span
          >
        </div>

        <div
          v-for="(item, index) in list"
          :key="index"
          class="col-xs-12 col-sm-4 col-md-3"
        >
          <div class="item-card user-card" v-if="!isGroup">
            <div class="header-card">
              <div class="user-name">
                <active-user-icon title="Usuário" />
                <h5>{{ item.LOGIN }}</h5>
              </div>
              <span class="perks">{{ getRole(item.PERMISSION) }}</span>
            </div>
            <div class="card-details">
              <div><span>Login:</span> {{ item.NAME }}</div>
              <div class="slider" v-if="item.EMAIL">
                <span>Email:</span> {{ item.EMAIL }}
              </div>
              <div class="slider" v-if="item.FK_GROUP">
                <span>Grupo:</span> {{ item.GROUP_NAME }}
              </div>
            </div>
            <div class="footer">
              <b-checkbox
                :value="item"
                v-show="isAdmin || activeUser.ID == item.ID"
                v-model="selected"
              />
            </div>
          </div>
          <div class="item-card group-card" v-else>
            <div class="header-card">
              <user-group-icon title="Usuário" />
              <div>{{ item.NAME }}</div>
            </div>
            
            <b-link  @click="openDetails(item)">
              <span>Ver itens associados </span>
              <search-icon title="Buscar" />
            </b-link>

            <div class="footer">
              <b-checkbox v-show="isAdmin" :value="item" v-model="selected" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      ref="remove"
      v-if="isAdmin"
      centered
      size=""
      ok-title="Deletar"
      ok-variant="danger"
      @ok="confirmRemove"
      cancel-title="Cancelar"
      cancel-variant="outline-secondary"
      title="Atenção!"
    >
      <div v-if="!isGroup" class="p-2">
        <div class="title-modal-info">
          {{
            selected.length == 1
              ? "1 usuário será apagado"
              : selected.length + " usuários serão apagados"
          }}.
        </div>
        <span
          v-if="!isGroup && selected.filter((e) => e.PERMISSION == 1).length"
          class="admin-alert"
          >Administrador(es) selecionado(s). Tem certeza de que deseja realizar
          esta ação?</span
        >
      </div>
      <div v-else class="title-modal-info">
        {{
          selected.length == 1
            ? "1 grupo será apagado"
            : `${selected.length} grupos serão apagados`
        }}
      </div>
    </b-modal>

    <b-modal
      v-if="isAdmin"
      ref="groupModal"
      centered
      size="lg"
      no-close-on-backdrop
      ok-title="Salvar"
      @ok="submitGroup"
      ok-variant="3v3"
      cancel-title="Fechar"
      @cancel="cancel"
      hide-header
    >
    </b-modal>

    <user-form
      v-if="
        !isGroup &&
        (isAdmin || (selected[0] && activeUser.ID == selected[0].ID))
      "
      :show-form="showForm"
      :form-type="formType"
      :old-login="
        formType == 'edit' && selected.length ? selected[0].LOGIN : ''
      "
      :item-to-edit="selected.length && selected[0]"
      :already-used-logins="fullList.map((e) => e.LOGIN)"
      :is-admin="isAdmin"
      :groups="groups"
      @submit="submit"
      @change-pwd="submitNewPWD"
      @close-form="resetForm"
    />

    <group-form
      v-if="isGroup && isAdmin"
      :show-form="showForm"
      :form-type="formType"
      :old-name="formType == 'edit' && selected.length ? selected[0].NAME : ''"
      :item-to-edit="selected.length && selected[0]"
      :already-used-names="fullList.map((e) => e.NAME)"
      :is-admin="isAdmin"
      :groups="groups"
      @submit="submitGroup"
      @close-form="resetForm"
      :all-elements="allElements"
      :related-elements="relatedElements"
      :users="users"
    />

    <!-- <div v-if="showElements">
      <div id="overlay" @click="showElements = false"></div>
      <div id="details">
        <header id="header" class="row">
          <div class="col-xs-12 monit-item bg-3v3">
            <h5>Grupo {{ details.NAME }}</h5>
          </div>
        </header>
        <div class="row">
          <div class="col-xs-12 content">
            <h5>Agendas</h5>
            <div class="selected-box">
              <div v-if="!details.AGN.length">
                Não há agendas cadastradas no setor {{ details.NAME }}.
              </div>
              <div
                class="selected-item"
                v-for="agn in details.AGN"
                :key="agn.ID"
              >
                {{ agn.NAME }}
              </div>
            </div>
            <h5>Bombas</h5>
            <div class="selected-box">
              <div v-if="!details.PUMP.length">
                Não há bombas cadastradas no setor {{ details.NAME }}.
              </div>
              <div
                class="selected-item"
                v-for="pump in details.PUMP"
                :key="pump.ID"
              >
                {{ pump.NAME }}
              </div>
            </div>
            <h5>Válvulas</h5>
            <div class="selected-box">
              <div v-if="!details.VALVE.length">
                Não há válvulas cadastradas no setor {{ details.NAME }}.
              </div>
              <div
                class="selected-item"
                v-for="valve in details.VALVE"
                :key="valve.ID"
              >
                {{ valve.NAME }}
              </div>
            </div>
            <h5>Hidrômetros</h5>
            <div class="selected-box">
              <div v-if="!details.HYDRO.length">
                Não há hidrômetros cadastrados no setor {{ details.NAME }}.
              </div>
              <div
                class="selected-item"
                v-for="hydro in details.HYDRO"
                :key="hydro.ID"
              >
                {{ hydro.NAME }}
              </div>
            </div>
            <h5>Sensores</h5>
            <div class="selected-box">
              <div v-if="!details.SENSOR.length">
                Não há sensores cadastrados no setor {{ details.NAME }}.
              </div>
              <div
                class="selected-item"
                v-for="sensor in details.SENSOR"
                :key="sensor.ID"
              >
                {{ sensor.NAME }}
              </div>
            </div>
            <h5>Usuários</h5>
            <div class="selected-box">
              <div v-if="!details.USERS.length">
                Não há usuários cadastrados no setor {{ details.NAME }}.
              </div>
              <div
                class="selected-item"
                v-for="user in details.USERS"
                :key="user.ID"
              >
                {{ user.NAME }}
              </div>
            </div>
          </div>
        </div>
        <footer id="footer">
          <b-btn size="sm" block @click="showElements = false"> Fechar </b-btn>
        </footer>
      </div>
    </div> -->
  </div>
</template>

<script>
import crypto from "crypto-browserify";
import { users, listEquipments } from "@/api";
import { user } from "@/pages/components/globalstore";
import { cookies } from "@/pages/components/cookies";
export default {
  name: "users",
  props: {
    mobile: Boolean,
  },
  created() {
    this.$emit("title-change", "Usuários");
    this.isActive();
    console.log("grupos")
  },
  data() {
    return {
      showForm: false,
      showElements: false,
      emptyIcon: require("../../../assets/icons/Empty.svg"),
      searchIcon: require("../../../assets/icons/search.svg"),
      //view
      isGroup: null,
      groups: [],
      loading: true,
      list: [],
      fullList: [],
      isSearching: false,
      filter: "",
      selected: [],
      allSelected: false,
      //edição ou adição de agenda
      formType: "add",
      fields: [
        {
          key: "CHECK",
        },
        {
          key: "NAME",
        },
      ],
      users: [],
      allElements: {
        //todos os elementos do sistema
        agn: [],
        hydro: [],
        pump: [],
        sensor: [],
        valve: [],
      },
      relatedElements: {
        //elementos que têm associação com grupos
        agn: [],
        hydro: [],
        pump: [],
        sensor: [],
        valve: [],
      },
      details: {},
      detailsTab: 0,
      showErrorNotFound: false,
      showErrorNotSearch: false,
    };
  },
  watch: {
    $route() {
      this.selected = [];
      this.allSelected = false;
      this.isActive();
    },
    selected() {
      this.allSelected = this.selected.length == this.list.length;
    },
    list() {
      this.allSelected =
        this.selected.length && this.selected.length == this.list.length;
    },
  },
  computed: {
    computedClass() {
      let className = "row align-items-center header";
      if (this.mobile) {
        className = "row align-items-center header-mobile";
        return className;
      }
      return className;
    },
    activeUser() {
      return {
        ID: Number(cookies.get("ID")),
        PERMISSION: Number(cookies.get("PERMISSION")),
      };
    },
    isAdmin() {
      return this.activeUser.PERMISSION === 1;
    },
    validFilter() {
      return !!this.filter.split(" ").join("");
    },
  },
  methods: {
    getRole(permissions) {
      switch (permissions) {
        case 1:
          return "Administrador";
        case 2:
          return "Usuário";
      }
    },
    resetDropdown() {
      this.isSearching = false;
      this.showErrorNotSearch = false;
      this.list = this.fullList;
      this.$refs.INP.clearText();
    },
    loadUsers() {
      this.showErrorNotSearch = false;
      this.showErrorNotFound = false;
      this.loading = true;
      this.isSearching = false;
      if (this.$refs.INP) {
        this.$refs.INP.clearText();
      }
      users
        .list()
        .then((ret) => {
          this.list = ret;
          this.fullList = this.list.map((e) => e);
        })
        .catch((err) => {
          alert("Erro ao carregar usuários.", "w");
          console.log(err);
        })
        .then((_) => (this.loading = false))
        .then((_) => {
          if (
            !this.list.length &&
            this.showErrorNotSearch === false &&
            !this.loading
          ) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        });
    },
    loadGroups() {
      this.showErrorNotSearch = false;
      this.showErrorNotFound = false;
      this.loading = true;
      this.isSearching = false;
      if (this.$refs.INP) {
        this.$refs.INP.clearText();
      }
      users.groups
        .list()
        .then((ret) => {
          this.list = ret;
          this.fullList = this.list.map((e) => e);
        })
        .catch((err) => {
          alert("Erro ao carregar grupos.", "w");
          console.log(err);
        })
        .then((_) => (this.loading = false))
        .then((_) => {
          if (
            !this.list.length &&
            this.showErrorNotSearch === false &&
            !this.loading
          ) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        });

      users.groups.relateds().then((ret) => {
        this.relatedElements = ret;
      });
    },
    isActive() {
      this.isGroup = this.$route.params.groups;
      this.list = [];
      this.isSearching = false;
      this.filter = "";
      this.showForm = false;
      if (this.isGroup) {
        this.loadGroups();
        users
          .list()
          .then((ret) => {
            this.users = ret;
          })
          .catch((err) => console.log(err));
        listEquipments
          .schedules()
          .then((agns) => {
            this.allElements.agn = agns;
          })
          .catch((err) => console.log(err));
        listEquipments
          .hydros()
          .then((hydros) => {
            this.allElements.hydro = hydros;
          })
          .catch((err) => console.log(err));
        listEquipments
          .pumps()
          .then((pumps) => {
            this.allElements.pump = pumps;
          })
          .catch((err) => console.log(err));
        listEquipments
          .sensors()
          .then((ret) => {
            this.allElements.sensor = ret.sensors;
          })
          .catch((err) => console.log(err));
        listEquipments
          .valves()
          .then((valves) => {
            this.allElements.valve = valves;
          })
          .catch((err) => console.log(err));
      } else {
        this.loadUsers();
        users.groups
          .list()
          .then((ret) => {
            this.groups = ret;
          })
          .catch((err) => console.log(err));
      }
    },
    //checkboxes
    toggleAll() {
      this.allSelected = !this.allSelected;
      if (this.selected.length < this.list.length)
        this.selected = this.list.slice();
      else if (this.selected.length == this.list.length) this.selected = [];
    },
    //modal de edição
    edit() {
      this.formType = "edit";
      this.showForm = true;
    },
    submitNewPWD(data) {
      users
        .changePwd({
          ID: data.ID,
          LOGIN: data.LOGIN,
          PSW: crypto.createHash("md5").update(data.PSW).digest("hex"),
        })
        .then((ret) => {
          alert(ret.log, ret.alert);
        })
        .catch((err) => {
          alert("Ocorreu um erro na alteração da senha. Tente novamente.");
        });
    },
    submit(data) {
      if (this.formType == "add")
        data.PSW = crypto.createHash("md5").update(data.PSW).digest("hex");
      users[this.formType](data)
        .then((ret) => {
          alert(ret.log, ret.alert);
          if (ret.alert == "s") {
            this.loadUsers();
            if (this.activeUser.ID == data.ID) {
              //autoconfig
              user.setLogin(data.LOGIN);
              user.setPermission(data.PERMISSION);
              this.$emit("change-active-user");
            }
          }
        })
        .catch((err) => {
          alert("Ocorreu um erro ao editar o usuário. Tente novamente.");
        })
        .then((_) => {
          this.resetForm();
        });
    },
    submitGroup(data) {
      users.groups[this.formType](data)
        .then((ret) => {
          alert(ret.log, ret.alert);
          if (ret.alert == "s") {
            this.loadGroups();
          }
          this.resetForm();
        })
        .catch((err) => console.log(err));
    },
    toggleAll(str) {
      if (str == "agns") {
        this.allAgnSelected = !this.allAgnSelected;
        if (this.selAgns.length < this.allElements.agn.length)
          this.selAgns = this.allElements.agn.map((e) => e.ID).slice();
        else if (this.selAgns.length == this.allElements.agn.length)
          this.selAgns = [];
      } else if (str == "valves") {
        this.allValveSelected = !this.allValveSelected;
        if (this.selValves.length < this.allElements.valves.length)
          this.selValves = this.allElements.valves.map((e) => e.ID).slice();
        else if (this.selValves.length == this.allElements.valves.length)
          this.selValves = [];
      } else if (str == "hydros") {
        this.allHydroSelected = !this.allHydroSelected;
        if (this.selHydros.length < this.allElements.hydros.length)
          this.selHydros = this.allElements.hydros.map((e) => e.ID).slice();
        else if (this.selHydros.length == this.allElements.hydros.length)
          this.selHydros = [];
      } else if (str == "pumps") {
        this.allPumpSelected = !this.allPumpSelected;
        if (this.selPumps.length < this.allElements.pumps.length)
          this.selPumps = this.allElements.pumps.map((e) => e.ID).slice();
        else if (this.selPumps.length == this.allElements.pumps.length)
          this.selPumps = [];
      } else if (str == "sensors") {
        this.allSensorSelected = !this.allSensorSelected;
        if (this.selSensors.length < this.allElements.sensors.length)
          this.selSensors = this.allElements.sensors.map((e) => e.ID).slice();
        else if (this.selSensors.length == this.allElements.sensors.length)
          this.selSensors = [];
      }
    },
    //comum à edição e adição
    cancel() {
      this.resetForm();
    },
    resetForm() {
      this.showForm = false;
      this.details = {};
      this.formType = "";
      this.selected = [];
    },
    remove() {
      this.$refs.remove.show();
    },
    confirmRemove() {
      if (!this.isGroup) {
        users
          .del(this.selected)
          .then((ret) => {
            alert(ret.log, ret.alert);
            if (ret.alert == "s") {
              this.loadUsers();
              this.selected = [];
            }
          })
          .catch((err) => {
            console.log(err);
            alert("Ocorreu um erro. Tente novamente.");
          })
          .finally(() => {
          this.resetPage();
          this.$refs.removeSectorDialog.hide();
        });
      } else {
        users.groups
          .del(this.selected)
          .then((ret) => {
            alert(ret.log, ret.alert);
            if (ret.alert == "s") {
              this.loadGroups();
              this.selected = [];
            }
          })
          .catch((err) => {
            console.log(err);
            alert("Ocorreu um erro. Tente novamente.");
          });
      }

    },
    add() {
      this.formType = "add";
      this.showForm = true;
    },
    searchBy(filter) {
      this.selected = [];
      this.isSearching = !!filter.split(" ").join("");
      this.filter = filter.toUpperCase();
      if (this.isSearching && this.validFilter && this.fullList.length) {
        this.list = this.fullList.filter((item) => {
          if(item.NAME.indexOf(this.filter) > -1){
            return true
          }
          return item.LOGIN.indexOf(this.filter) > -1
        });
        if (this.list.length) {
          this.showErrorNotSearch = false;
        } else {
          this.showErrorNotSearch = true;
        }
      } else {
        this.list = this.fullList.map((e) => e);
      }
    },
    clearSearch() {
      this.selected = [];
      this.isSearching = false;
      this.$refs.INP.clearText();
      this.showErrorNotSearch = false;
      this.list = this.fullList.map((e) => e);
    },
    orderByKey(key, order = "asc") {
      // function for dynamic sorting
      return function (a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0; // property doesn't exist on either object
        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];
        let comparison = 0;
        if (varA > varB) comparison = 1;
        else if (varA < varB) comparison = -1;
        return order == "desc" ? comparison * -1 : comparison;
      };
    },
    openGroupElements(group) {
      this.details = group;
      this.details.USERS = this.users.length
        ? this.users.filter((e) => e.FK_GROUP == group.ID)
        : [];
      this.details.AGN = this.relatedElements.agn.length
        ? this.relatedElements.agn.filter((e) => e.ID_GROUP == group.ID)
        : [];
      this.details.HYDRO = this.relatedElements.hydro.length
        ? this.relatedElements.hydro.filter((e) => e.ID_GROUP == group.ID)
        : [];
      this.details.PUMP = this.relatedElements.pump.length
        ? this.relatedElements.pump.filter((e) => e.ID_GROUP == group.ID)
        : [];
      this.details.SENSOR = this.relatedElements.sensor.length
        ? this.relatedElements.sensor.filter((e) => e.ID_GROUP == group.ID)
        : [];
      this.details.VALVE = this.relatedElements.valve.length
        ? this.relatedElements.valve.filter((e) => e.ID_GROUP == group.ID)
        : [];
      this.$nextTick(function () {
        this.showElements = true;
      });
    },
  },
};
</script>

<style scoped>
.group-card a {
  width: 143px;
  padding: 0.5px;
  border-radius: 5px;
  border: 1px solid #bebebe;
  font-weight: 500;
  font-size: 0.7em;
  color: #a1a1a1;
  transition: all 0.4s ease;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.group-card .material-design-icon {
  padding: 0;
  font-size: 1.3em;
  margin-left: 4px;
  margin-top: -4px;
}
.group-card a:hover {
  background: #f7f7f7;
  border: 1px solid #bebebe;
}
.scrollable {
  max-height: 305px;
  overflow: auto;
}
.group-card {
  word-wrap: break-word;
  height: 100px;
}
.group-user-list {
  overflow: auto;
  height: 210px;
}
.group-user {
  width: 100%;
  background-color: #f5f5f5;
  margin-bottom: 2px;
  color: var(--text-gray-primary);
  padding-left: 5px;
  overflow: hidden;
}
.group-card .header-card {
  color: var(--text-gray-primary);
  font-weight: 600;
  font-size: 1.2em;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  margin-bottom: 5px;
  padding-bottom: 5px;
}
.group-card .header-card div {
  height: 22px;
}
.group-card .header-card .material-design-icon {
  margin: 0;
  padding: 0;
  font-size: 1.2em;
}
p {
  margin-bottom: 5px;
}
.title-modal-info {
  font-size: 1.2em;
}
.admin-alert {
  color: #b42020;
  font-size: 0.85em;
}
.user-card {
  word-wrap: break-word;
  height: 145px;
  padding-bottom: 55px !important;
  max-height: 235px;
}
.material-design-icon {
  font-size: 22.5px;
}
#details {
  padding-top: 100px;
  padding-bottom: 0 !important;
}
.list-items {
  padding: 5px;
}
.card-details {
  padding-top: 3px;
  max-height: 55px;
  overflow-y: auto;
  font-size: 0.86em;
  color: var(--text-gray-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3em;
}
.card-details strong {
  color: var(--text-gray-primary);
}
.card-details span {
  font-weight: 600;
}
.header {
  flex-basis: 34px;
}
.header-card {
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
}
.header-card .user-name {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
}
.header-card .user-name h5 {
  color: var(--text-gray-primary);
  font-weight: 600;
}
.header-card .user-name span {
  max-height: 0.8em;
}
.header-card .user-name .material-design-icon {
  font-size: 1.2em;
  margin-right: 0.1em;
  font-weight: 600;
  color: #838383;
}
.user-card .header-card .perks {
  font-size: 0.88em;
}
.header-mobile {
  min-height: 90px;
}
.list-items .footer {
  height: 25px;
}
@media screen and (max-width: 767px) {
  #details .content {
    padding-bottom: 90px !important;
  }
  #form, #details {
    padding-top: 2.5em;
}
}

</style>
